import { 
  NotificationListResponse, 
  NotificationReadResponse, 
  NotificationListParams 
} from '../types/notification';
import { apiClient } from '.';

// 알림 목록 조회 API
export const fetchNotifications = async (params: NotificationListParams = {}): Promise<NotificationListResponse> => {
  const searchParams = new URLSearchParams();
  
  if (params.isRead !== undefined) {
    searchParams.append('isRead', params.isRead.toString());
  }
  if (params.startDate) {
    searchParams.append('startDate', params.startDate);
  }
  if (params.endDate) {
    searchParams.append('endDate', params.endDate);
  }

  const url = `/api/notify/list${searchParams.toString() ? `?${searchParams.toString()}` : ''}`;

  try {
    const { data } = await apiClient.get<NotificationListResponse>(
      url,
      { withCredentials: true }
    );
    return data;
  } catch (error) {
    /// console.error(`[notificationApi] 알림 목록 조회 실패:`, error);
    throw error;
  }
};

// 특정 알림 읽음 처리 API
export const markNotificationAsRead = async (notificationId: number): Promise<NotificationReadResponse> => {
  const url = `/api/notify/read/${notificationId}`;

  try {
    const { data } = await apiClient.get<NotificationReadResponse>(
      url,
      { withCredentials: true }
    );
    /// console.log(`알림 읽음 처리 API 응답 데이터:`, {data});
    
    return data;
  } catch (error) {
    /// console.error(`[notificationApi] 알림 읽음 처리 실패:`, error);
    throw error;
  }
};

// 읽지 않은 알림 개수 조회
export const getUnreadNotificationCount = async (): Promise<number> => {
  try {
    const response = await fetchNotifications({ isRead: false });
    return response.data.length;
  } catch (error) {
    /// console.error('[notificationApi] 읽지 않은 알림 개수 조회 실패:', error);
    return 0;
  }
};
